import React from "react"
import "./SearchBar.css"

const SearchBar = ({ valueChanged }) => {
  const searchInput = React.createRef()

  return (
    <div className="search" onClick={() => searchInput.current.focus()}>
      <form className="search-field">
        <input
          ref={searchInput}
          type="text"
          name="search"
          placeholder="Search for an icon"
          autoComplete="off"
          onKeyUp={valueChanged}
        />
      </form>
    </div>
  )
}

export default SearchBar
